import { z } from "zod";

import { machineCorrugateTrackSchema } from "../utils/machine-corrugate-track";

const MILLIMETERS_PER_INCH = 25.4;

const roundToTwoDecimalPlaces = (value: number): number => {
	return Math.round((value + Number.EPSILON) * 100) / 100;
};

const convertToMillimeters = (value: number, tenantUsesInches: boolean): number => {
	if (tenantUsesInches === false) {
		return value;
	}

	return roundToTwoDecimalPlaces(value * MILLIMETERS_PER_INCH);
};

export const getX4ChangeCorrugatePayloadSchema = (tenantUsesInches: boolean) =>
	z.array(machineCorrugateTrackSchema).transform((tracks) =>
		tracks.map((track) => ({
			trackNumber: track.number,
			loadedCorrugate: {
				...track.assignedMaterial,
				width: convertToMillimeters(track.assignedMaterial.width, tenantUsesInches),
				thickness: convertToMillimeters(track.assignedMaterial.thickness, tenantUsesInches),
			},
			trackOffset: track.trackOffset,
			isTrackEmpty: track.isEmpty,
		})),
	);

export type X4ChangeCorrugatePayload = z.infer<ReturnType<typeof getX4ChangeCorrugatePayloadSchema>>;
